/**
 * Convert text to a URL-safe slug.
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')   // Remove non-word chars except spaces and hyphens
    .replace(/[\s_]+/g, '-')     // Replace spaces/underscores with hyphens
    .replace(/-+/g, '-')         // Collapse multiple hyphens
    .replace(/^-+|-+$/g, '')     // Trim hyphens from start/end
}

/**
 * Generate a slug for a product's IFU or DoC document.
 * e.g. "Eclipse Glasses Shape A" + "ifu" → "eclipse-glasses-shape-a-ifu"
 */
export function generateDocumentSlug(productName: string, docType: 'ifu' | 'doc'): string {
  return `${slugify(productName)}-${docType}`
}

/**
 * Generate a slug for a custom document.
 * e.g. "Eclipse Glasses" + "User Manual" → "eclipse-glasses-user-manual"
 */
export function generateCustomDocSlug(productName: string, docDisplayName: string): string {
  return `${slugify(productName)}-${slugify(docDisplayName)}`
}
